<script lang="ts" setup>
import { useModal } from 'vue-final-modal'

import BasicButton from '~/components/form-elements/BasicButton.vue'
import AnyPickupPoint from '~/components/modal-windows/shipping/AnyPickupPoint.vue'
import { useCartStore } from '~/store/cart'

const cartStore = useCartStore()

async function openAnyPickupPointModalWindow (): Promise<void> {
  await useModal({
    component: AnyPickupPoint,
    attrs: { declaredValueInKopecks: cartStore.subtotalWithDiscountInKopecks }
  }).open()
}
</script>

<template>
  <div>
    <Notification class="my-6" is-small status="info">
      <template v-if="cartStore.shippingData">
        Адрес выбранного ПВЗ: {{ cartStore.shippingData.fullAddress }}.
      </template>
      <template v-else-if="cartStore.isShippingCostKnown">
        Выберите пункт выдачи заказов (ПВЗ).
      </template>
      <template v-else>
        Выберите пункт выдачи заказов (ПВЗ) и&nbsp;узнайте стоимость доставки.
      </template>
    </Notification>

    <BasicButton
      color="body-background"
      :title="cartStore.shippingData ? 'Изменить ПВЗ' : 'Выбрать ПВЗ'"
      @click="openAnyPickupPointModalWindow"
    />
  </div>
</template>
